import * as Clipboard from 'expo-clipboard';
import { getIntl } from '../utils/intl';
import useNotify from './useNotify';
import { notifyBugsnag } from '../utils/bugsnag';

const intl = getIntl('useCopyToClipboard', {
    copied: 'Successfully copied to clipboard',
    failedToCopy: 'Failed to copy to clipboard',
});

export type UseCopyToClipboardArgs = {
    successMessage?: string;
    errorMessage?: string;
};

export type UseCopyToClipboardReturn = {
    copyToClipboard: (text: string) => void;
};

export const useCopyToClipboard = ({
    successMessage = intl('copied'),
    errorMessage = intl('failedToCopy'),
}: UseCopyToClipboardArgs): UseCopyToClipboardReturn => {
    const notify = useNotify();
    const copyToClipboard = (text: string) => {
        Clipboard.setStringAsync(text)
            .then(() => {
                notify('success', successMessage);
            })
            .catch((e) => {
                notifyBugsnag(e);
                notify('error', errorMessage);
            });
    };

    return { copyToClipboard };
};
